import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SchedulerListComponent } from './scheduler-list.component';
import { CtModelModule } from '@ctsolution/ct-framework';
import { SchedulerDialogModule } from '../scheduler-dialog/scheduler-dialog.module';

/**
 * Modulo per il componente SchedulerList
 * Include il modulo SchedulerDialog per supportare l'apertura in modale
 */
@NgModule({
  imports: [
    CommonModule,
    CtModelModule,
    SchedulerDialogModule  // Importa il modulo della modale
  ],
  declarations: [SchedulerListComponent],
  exports: [SchedulerListComponent]
})
export class SchedulerListModule { }
